import React from 'react';

const SVG = ({ file, name, events }) => (
  <div className={name} dangerouslySetInnerHTML={{__html: file}} {...events} />
);

SVG.propTypes = {
  file: React.PropTypes.string.isRequired,
  name: React.PropTypes.string.isRequired,
  events: React.PropTypes.object
};

export default SVG;



// WEBPACK FOOTER //
// ./src/components/SVG.js